import React from 'react'
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import listPlugin from '@fullcalendar/list'
import interactionPlugin from '@fullcalendar/interaction'
import ptLocale from '@fullcalendar/core/locales/pt'
import ruLocale from '@fullcalendar/core/locales/ru'
import palette from 'utils/enums/theme'
import {convertColor} from 'utils/utils'

const Scheduler = ({colorScheme, colors, eventLimitClick, defaultView, language,
    eventDrop, dateClick, eventClick, data, scheduler, getLabel, getColorId, getColor, calendarRef}) => {
    
    const scheme = Object.values(palette).find(item => item.id === colorScheme)
	const colorsEmpty = !colors.find(item => item.color)
    const modifiedСolors = colors.map((item, index) => {
        return {
            ...item,
            color: item.color ? convertColor(item.color) :
				colorsEmpty ? scheme.colors[index % scheme.colors.length] : scheme.colors[0]
        }
    })
	
    return (
        <FullCalendar
            ref={calendarRef}
            headerToolbar ={{
                center: 'title',
                end: '',
                start: 'prev next today'
            }}
            views={{
                dayGridMonth: {
                    dayMaxEventRows: 4
                }
            }}
            moreLinkClick={eventLimitClick}
            initialView={defaultView}
            locales={[ ptLocale, ruLocale ]}
            firstDay={1}
            locale={language}
            plugins={[ dayGridPlugin, listPlugin, interactionPlugin ]}
            editable={true}
            eventDurationEditable={false}
            eventDrop={eventDrop}
            dateClick={dateClick}
            eventClick={eventClick}
			eventDisplay='block'
            height='100%'
			dayMaxEventRows={true}
			expandRows={true}
            eventTimeFormat={{
                hour: '2-digit',
                minute: '2-digit',
                meridiem: false,
                hour12: false
            }}
            events={data.map((item) => {
                const colorId = scheduler ? getColorId(item) : item.colorId
                const colorField = modifiedСolors.find(obj => obj.id === colorId)
                const color = colorField ? colorField.color : ''
                const {text, background, border} = scheduler ? getColor(item, color) : {}

                return {
                    id: item.id,
                    title: scheduler ? getLabel(item) : item.label,
                    start: item.from,
                    end: item.to,
                    backgroundColor: background ? background : `rgba(${color}, 0.7)`,
                    borderColor: border ? border : `rgba(${color}, 0.7)`,
                    textColor: text ? text : ''
                }
            })}
        />
    )
}

export default React.memo(React.forwardRef((props, ref) => <Scheduler calendarRef={ref} {...props} />))
